export const BOOKING_TIPS = [
  {
    title: "👉 Important Next Step",
    description:
      "Use ONLY FreightSimple's generated Pickup Package, which includes your Bill of Lading and shipment documents. Using other documents may cause delays, extra charges, and void FreightSimple coverage.",
    link: "https://help.freightsimple.com/using-freightsimple/booking-your-shipment/your-pickup-package",
  },
  {
    title: "📦 Be prepared",
    description:
      "Your driver will need the Bill of Lading, customs documents (for cross-border), and any MSDS forms for dangerous goods. Have them ready to avoid pickup delays!",
    link: "https://help.freightsimple.com/freight-101/instructions-for-the-pickup-contact",
  },

  {
    title: "🚛 Pre-clearance is key",
    description:
      "Carriers won't load cross-border freight onto trucks until customs are cleared - upload your documents early to avoid delays!",
    link: "https://help.freightsimple.com/using-freightsimple/booking-your-shipment/uploading-your-customs-documents",
  },
  {
    title: "📄 Missing customs docs = delays",
    description:
      "For cross-border shipments, incomplete or incorrect customs documents can delay pickup and may result in additional carrier charges.",
    link: "https://help.freightsimple.com/using-freightsimple/booking-your-shipment/uploading-your-customs-documents",
  },
  {
    title: "🔗 Not handling pickup yourself?",
    description:
      "Use the 'Share' link in your shipment to give your pickup contact easy access to all required documents and details!",
    link: "https://help.freightsimple.com/using-freightsimple/booking-your-shipment/share-pickup-information",
  },
];
